export default __webpack_public_path__ + "static/media/box-cascade-green.60046535.svg";